/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
    This function handles hiding the sticky add to cart bar
    on product pages.
 */
(function () {

    var stickyBuyBar = document.querySelector('.Product__MobileStickyBuy');

    if (!stickyBuyBar) return;

    var barHeight = stickyBuyBar.offsetHeight + 1;
    var isAnimating = false;

    var onScroll = function () {
        requestAnimationFrame(function () {
            var barPos = Math.round(stickyBuyBar.getBoundingClientRect().top);

            if (isAnimating) return;

            if (
                !stickyBuyBar.classList.contains('Product__MobileStickyBuy--hidden') &&
                (barPos + barHeight) < window.innerHeight &&
                !isAnimating
            ) {
                isAnimating = true;
                stickyBuyBar.classList.add('Product__MobileStickyBuy--hidden');
                stickyBuyBar.style.marginBottom = (0 - barHeight) + 'px';

                setTimeout(function () {
                    isAnimating = false;
                }, 350);
            } else if (
                stickyBuyBar.classList.contains('Product__MobileStickyBuy--hidden') &&
                (barPos + barHeight) >= window.innerHeight &&
                !isAnimating
            ) {
                isAnimating = true;
                stickyBuyBar.classList.remove('Product__MobileStickyBuy--hidden');
                stickyBuyBar.style.marginBottom = 0;
            }

            setTimeout(function () {
                isAnimating = false;
            }, 350);
        });
    }

    window.addEventListener('scroll', onScroll);
})();
/*
    We save the header height to make transitions smoother when
    changing to the non-transparent header. This function
    recalculates the saved value when a user resizes the
    browser.
 */
(function () {
    var onResize = function () {
        return requestAnimationFrame(function () {
            // save header height space.
            var section = document.querySelector('.shopify-section--header');
            var header = null;
            var search = null;

            if (section) {
                header = section.querySelector('.Header');
                search = section.querySelector('.Search');
            }

            if (header) section.style.minHeight = header.offsetHeight + 'px';
            if (search) search.style.minHeight = header.offsetHeight + 'px'
        });
    }

    window.addEventListener('resize', onResize);
    onResize();
})();
/*
    This sets the position of the mobile zoom button on product pages
 */
(function () {
    var onScroll = function () {
        return requestAnimationFrame(function () {
            var bar = document.querySelector('.Product__MobileStickyBuy');
            var actions = document.querySelector('.Product__ActionList');

            if (bar && actions) {
                var top = bar.offsetHeight + 17.5;
                actions.style.top = 'calc(100% - ' + top + 'px)';
            }

            if (actions) actions.classList.remove('hidden-phone');
        });
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
})();

(function () {
    var width = window.innerWidth;
    window.addEventListener('resize', function () {
        return requestAnimationFrame(function () {
            if (window.innerWidth !== width)
                window.location.reload();
        })
    });
})();

(function () {
    fetch('https://www.cloudflare.com/cdn-cgi/trace')
        .then(res => res.text() ).then(t => {
        var data = t.replace(/[\r\n]+/g, '","').replace(/\=+/g, '":"');
        data = '{"' + data.slice(0, data.lastIndexOf('","')) + '"}';
        var jsondata = JSON.parse(data);
        //console.log('Location: ' + jsondata.loc);
        document.querySelector('body').classList.add('country-'+jsondata.loc)
    });
})();